import {ColorFilter} from "@/poster-gallery/classes/advanced-filters/color-filter";
import {AnimationFilter} from "@/poster-gallery/classes/advanced-filters/animation-filter";
import {OrientationFilter} from "@/poster-gallery/classes/advanced-filters/orientation-filter";
import {ContentTypeFilter} from "@/poster-gallery/classes/content-type-filter";
import {DesignStyleFilter} from "@/poster-gallery/classes/advanced-filters/design-style-filter.js";

export class AdvancedFilterFactory {
    /**
     * @param {string} advancedFiltersArrayKey
     * @param {{filterOption: string, wasOptionSelectedByUser: boolean, lastOptionSelectedByUser: string}} popstateObj
     * @return {OrientationFilter|ColorFilter|AnimationFilter|ContentTypeFilter|null}
     */
    static fromPopstateObj(advancedFiltersArrayKey, popstateObj) {
        const popstateFilter = this.fromArrayKeyAndFilterOption(advancedFiltersArrayKey, popstateObj.filterOption);
        popstateFilter.setWasOptionSelectedByUser(popstateObj.wasOptionSelectedByUser);
        popstateFilter.setLastOptionSelectedByUser(popstateObj.lastOptionSelectedByUser);
        return popstateFilter;
    }

    /**
     * @param {AdvancedFilter} filter
     * @return {AdvancedFilter}
     */
    static cloneFilter(filter) {
        const clonedFilter = AdvancedFilterFactory.fromArrayKeyAndFilterOption(filter.advancedFiltersArrayKey, filter.filterOption);
        clonedFilter.setState(filter.getState());
        clonedFilter.oldFilterOption = filter.oldFilterOption;
        clonedFilter.setLastOptionSelectedByUser(filter.lastOptionSelectedByUser);
        clonedFilter.setWasOptionSelectedByUser(filter.wasOptionSelectedByUser);
        return clonedFilter;
    }

    /**
     * @param {jQuery} clickedFilterOption
     * @return {AdvancedFilter}
     */
    static fromFilterOption(clickedFilterOption) {
        const filterOption = clickedFilterOption.attr('data-filter-option'),
            advancedFiltersArrayKey = clickedFilterOption.attr('data-filter-type');

        return AdvancedFilterFactory.fromArrayKeyAndFilterOption(advancedFiltersArrayKey, filterOption);
    }

    /**
     * @param {string} advancedFiltersArrayKey
     * @param {string} filterOption
     * @return {OrientationFilter|ColorFilter|AnimationFilter|ContentTypeFilter|DesignStyleFilter|null}
     */
    static fromArrayKeyAndFilterOption(advancedFiltersArrayKey, filterOption) {
        switch (advancedFiltersArrayKey) {
            case ColorFilter.advancedFiltersArrayKey: {
                return new ColorFilter(filterOption, advancedFiltersArrayKey);
            }

            case AnimationFilter.advancedFiltersArrayKey: {
                return new AnimationFilter(filterOption, advancedFiltersArrayKey);
            }

            case OrientationFilter.advancedFiltersArrayKey: {
                return new OrientationFilter(filterOption, advancedFiltersArrayKey);
            }

            case ContentTypeFilter.advancedFiltersArrayKey: {
                return new ContentTypeFilter(filterOption, advancedFiltersArrayKey);
            }

            case DesignStyleFilter.advancedFiltersArrayKey: {
                return new DesignStyleFilter(filterOption, advancedFiltersArrayKey);
            }

            default: {
                return null;
            }
        }
    }
}